import classNames from 'classnames';
import EllipsedStar from 'assets/img/icons/ellipsed-star.svg?react';

import s from './styles.module.scss';

import type { IPatientBingoProgress } from 'infrastructure/interfaces/i-patient-bingo-progress';

interface IBingoWonStatusProps {
  value: IPatientBingoProgress;
}

export default function BingoWonStatus(props: IBingoWonStatusProps) {
  const { value } = props;

  const statusClass = classNames(s.bingoStatus, {
    [s['bingoStatus--won']]: value.isWon,
    [s['bingoStatus--in-progress']]:
      !value.isWon && value.openedNumbers.length > 0,
    [s['bingoStatus--no-progress']]:
      !value.isWon && value.openedNumbers.length === 0,
  });

  return (
    <span className={statusClass} data-cy="bingo-isWon">
      <EllipsedStar width={20} height={20} />
      {value.isWon ? (
        <p style={{ margin: 0 }}>BINGO!</p>
      ) : (
        <p style={{ margin: 0 }}>{value.openedNumbers.length}</p>
      )}
    </span>
  );
}
